module.exports = __webpack_public_path__ + "img/vue1-toebox_rouge.407368fa.png";